import { TrialTopHeader } from '@iblai/ibl-web-react-common';
import useSubscriptionStatus from '../../hooks/subscription/useSubscriptionStatus';
import { useTriggers } from '../../hooks/navigation';

export default function SubscriptionInactiveBanner() {
  /*const tooltip = `Your subscription is currently inactive. You need to renew or update your payment details`;
  const pillDisplay = `Update`;
  const description = `Your subscription is currently inactive. You need to renew or update your payment details`;*/

  const {
    show,
    handleGotoPaymentUpdate,
    tooltip,
    pillDisplay,
    description,
    customerPortalURL,
  } = useSubscriptionStatus();

  const { handleSeePricingIframeBoxClick } = useTriggers();

  return (
    <>
      {show && (
        <TrialTopHeader
          descriptionText={description}
          pillDisplayText={pillDisplay}
          tooltipText={tooltip}
          handleClick={
            customerPortalURL
              ? () => {
                  window.location.href = customerPortalURL;
                }
              : handleSeePricingIframeBoxClick
          }
          fixedClassNamesToMove=".header, .main-content"
        />
      )}
    </>
  );
}
